import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { resetActiveOrderHistory } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import { isOrderCompletedOnFulfillmentDateTime } from 'common/utilities/orderStatusUtils';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { redirectToHomePage } from 'common/utilities/utils';

const getActiveOrdersView = params => {
  return <LazyLoaderWrapper {...params} testId='activeOrdersView' importPath='ACTIVE_ORDERS_VIEW'></LazyLoaderWrapper>;
};

const ActiveOrders = props => {
  const dispatch = useDispatch();
  const { tenantReducer, orderHistoryReducer, profileReducer } = useSelector(data => data);
  const { componentOptions: { web: { orderPages: { enableReadytoCollectLabel } = {} } = {} } = {} } = tenantReducer;

  const [activeTrackerDetails, setActiveTrackerDetails] = useState({
    props,
    customerId: null,
    tenantId: null,
    postActiveOrderHistoryDetailsList: [],
    customer: null,
    dispatch,
    pickupTrackOrderButtonLabel: null,
  });

  const updateSetActiveTrackerDetails = useCallback(param => {
    setActiveTrackerDetails && setActiveTrackerDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  useEffect(() => {
    return () => dispatch(resetActiveOrderHistory());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    updateSetActiveTrackerDetails({
      customerId: profileReducer?.customerId,
      customer: profileReducer?.basic,
      tenantId: tenantReducer?.tenantId,
      pickupTrackOrderButtonLabel: tenantReducer?.componentOptions?.web?.orderPages?.pickupTrackOrderButtonLabel,
      enableGlobalOrderTracking: tenantReducer?.componentOptions?.web?.orderPages?.enableGlobalOrderTracking,
      enableReadytoCollectLabel,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    profileReducer?.customerId,
    tenantReducer?.tenantId,
    tenantReducer?.componentOptions?.web?.orderPages?.pickupTrackOrderButtonLabel,
  ]);

  useEffect(() => {
    if (
      orderHistoryReducer &&
      orderHistoryReducer?.activeOrderHistory &&
      !orderHistoryReducer?.activeOrderHistoryLoading &&
      orderHistoryReducer?.activeOrderHistory?.length > 0
    ) {
      updateSetActiveTrackerDetails({
        postActiveOrderHistoryDetailsList: orderHistoryReducer?.activeOrderHistory?.filter(
          item => !isOrderCompletedOnFulfillmentDateTime(item),
        ),
      });
    }
    if (!orderHistoryReducer?.activeOrderHistoryLoading && orderHistoryReducer?.activeOrderHistory?.length === 0) {
      redirectToHomePage(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderHistoryReducer?.activeOrderHistory]);

  return getActiveOrdersView({ activeTrackerDetails });
};

export default ActiveOrders;
